<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div style="width: 100%; display: flex; align-items: center; margin-bottom: 5px;">
                <div class="ml-auto">
                    <b-button size="sm" variant="outline-success" @click="onAggiungiArticoloDistintaBase()">
                        <font-awesome-icon icon="edit" /> Aggiungi
                    </b-button>
                </div>
            </div>
            <div class="b-table-sticky-header">
                <template v-if="items.length > 0">
                    <b-table sticky-header stacked="lg" striped hover :items="items" :fields="fields" sort-icon-left
                        head-variant="light" class="sa-b-table" current-page="1" :per-page="perPage">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(idArticolo)="row">
                            <b>{{ row.item.descrizioneArticolo }}</b>

                        </template>
                        <template #cell(quantita)="row">
                            <span v-if="!isEdit">{{ row.item.quantita }}</span>
                            <b-form-input v-else type="number" v-model="row.item.quantita"></b-form-input>
                        </template>
                        <template #cell(idUm)="row">
                            <span v-if="!isEdit">{{ row.item.descrizioneUm }}</span>
                            <b-form-select v-else value-field="id" text-field="descrizioneMultiplo"
                                v-model="row.item.idUm" :options="row.item.unitaMisuraOptions"></b-form-select>
                            <!-- @change="onChangeUnitaMisura($event, row)" -->
                        </template>
                        <template #cell(giacenza)="row">
                            <template v-if="row.item.infogiacenza">
                                <div
                                    style="display: flex; align-items: center; justify-content: center; font-family: sans-serif;">
                                    <span style="font-weight: 600; font-size: 1.1rem; color: #333;">
                                        {{ row.item.infogiacenza ? row.item.infogiacenza.giacenza : 0 }}
                                    </span>
                                    <font-awesome-icon
                                        v-if="row.item.infogiacenza.giacenza <= row.item.infogiacenza.sottoscorta"
                                        icon="exclamation-triangle"
                                        style="color: #ff9800; margin-left: 8px; font-size: 0.9rem;" />
                                </div>
                            </template>
                            <template v-else>
                                <b>0</b>
                            </template>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row mt-2">
                                <b-button size="sm" v-b-tooltip.hover class="mr-1 no-text"
                                    title="Rimuovi Articolo Distinta" variant="outline-danger"
                                    @click="onCLickRimuoviArticolo(row)">
                                    <font-awesome-icon icon="trash" />
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </template>
                <template v-else>
                    <NoDataComponent ref="cmpNoDataComponent" title="Non sono presenti Articoli per Distinta Base "
                        nome="no-data" subtitle="" icon="fas fa-file" />
                </template>

            </div>
        </div>
        <div class="sa-list-component-footer">
            <MagazzinoArticoliDistintaBaseEditModal @onAddArticolo="onAddArticolo"
                ref="mdlMagazzinoArticoliDistintaBaseEditModal" />
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: 0</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="0" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliDistintaBaseEditModal from "./MagazzinoArticoliDistintaBaseEditModal.vue";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
import axios from "axios";

export default {

    mixins: [UtilityMixin, MagazzinoMixins],
    components: { NoDataComponent, MagazzinoArticoliDistintaBaseEditModal },
    data() {
        return {
            pathResource: "/magazzinoarticolidistintabase/articolo",
            articoloDifferitaBase: "",
            rows: 0,
            perPage: 50,
            isEdit: true,
            currentPage: 1,
            nuovaRiga: {
                idArticolo: null, descrizioneArticolo: null, idDistintaBase: this.idArticolo, quantita: 0, idUm: null, descrizioneUm: null
            },
            idArticolo: null,
            items: [],
            jsonData: {
                distintaBase: []
            },
            fields: [{
                label: "",
                key: "index",
                sortable: false,
                thStyle: "width: 2rem",
            },
            { label: "Articolo", key: "idArticolo", sortable: true },
            {
                label: "Qtn.",
                key: "quantita",
                thStyle: "width: 10rem",
            },
            {
                label: "Giacenza",
                key: "giacenza",
                thClass: "text-center"

            },
            {
                label: "Unita Misura",
                key: "idUm"
            },
            { class: "sa-table-column-action-double", key: "actions", label: "" },]

        };
    },
    mounted() {
        this.mangazzinoArticoliUnitaMisuraLoadData();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(filtro, jsonData) {
            this.idArticolo = filtro.idArticolo;
            this.jsonData = jsonData;
            if (this.idArticolo != null && this.idArticolo !== "-1") {
                this.loadData();
            }
            this.articoloDifferitaBase = jsonData.nomeArticolo;
        },
        onAddArticolo(articolo) {
            this.items.push(articolo);
            this.$set(articolo, 'unitaMisuraOptions', []);
            this.loadOptionsForArticolo(articolo);
            this.emitDistintaBaseUpdate();
        },
        getOptionArticolo(idArticolo) {
            let link = process.env.VUE_APP_PATH_API + "/magazzinoarticoli/" + idArticolo;
            axios.get(link).then((response) => {
                let articolo = response.data.data;
                return this.magazzinoArticoliUnitaMisuraOptions.filter(e => e.id == articolo.umId || e.id == articolo.umBaseId)

            });

        },
        onAfterSave() {
            console.log("onAfterSave");
        },
        emitDistintaBaseUpdate() {
            this.$emit("updateDistintaBase", this.items);
        },
        loadData(idArticolo) {
            if (idArticolo != null) {
                this.idArticolo = idArticolo;
            }
            let filter = {
                idArticolo: this.idArticolo
            }
            UtilityMixin.methods.loadDataResources(this.pathResource, filter, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            this.items = response.data.data;
            response.data.data.forEach(item => {
                this.$set(item, 'unitaMisuraOptions', []);
                this.loadOptionsForArticolo(item);
            });
            this.emitDistintaBaseUpdate();
        },
        loadOptionsForArticolo(item) {
            let link = process.env.VUE_APP_PATH_API + "/magazzinoarticoli/" + item.idArticolo;
            axios.get(link).then((response) => {
                let articolo = response.data.data;
                item.unitaMisuraOptions = this.magazzinoArticoliUnitaMisuraOptions.filter(
                    e => e.id == articolo.umId || e.id == articolo.umBaseId
                ).map(e => ({
                    id: e.id,
                    descrizioneMultiplo: e.descrizioneMultiplo
                }));
                item.infogiacenza = {
                    giacenza: articolo.giacenze,
                    sottoscorta: articolo.sottoscortaArticolo
                }
            });
        },
        loadDataError(error) {
            console.log(error);
        },
        onAggiungiArticoloDistintaBase() {
            this.$refs.mdlMagazzinoArticoliDistintaBaseEditModal.init({ idArticolo: this.idArticolo }, this.jsonData);
        },
        onCLickRimuoviArticolo(row) {
            this.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo articolo dalla Distinta Base?", {
                    title: "Eliminazione Articolo Distinta Base",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.items.splice(row.index, 1);
                        this.emitDistintaBaseUpdate();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

        }


    },



};
</script>

<style></style>
